<template>
    <div class="contentNum">
        <div>
            <div class="contentCenterTitle">门店数量（家）</div>
            <div class="dl">
                <div class="centerNum" v-for="(item, i) in num1length" :key="i"><span>{{ num1total[i] }}</span></div>
            </div>
        </div>
        <div>
            <div class="contentCenterTitle">总实际营业额（万元）</div>
            <div class="dl">
                <div class="centerNum" v-for="(item, i) in num2length" :key="i"><span>{{ num2total[i]  }}</span></div>
            </div>
        </div>
        <div>
            <div class="contentCenterTitle">总销售笔数（笔）</div>
            <div class="dl">
                <div class="centerNum" v-for="(item, i) in num3length" :key="i"><span>{{ num3total[i]  }}</span></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'template.centerTop',
    // 传入对象格式，格式内num123分别对应前几个，numlength对应格子长度
    props: {
        vdata: {
            type: Object,
            default: () => {}
            // default: {
            //     num1: 532,
            //     num2: 699,
            //     num3: 598
            // }
        },
    },
    data() {
        return {
            num1length: 3,
            num2length: 9,
            num3length: 5,
            num1: 696,
            num1total: 0,
            num2: 525,
            num2total: 0,
            num3: 1233,
            num3total: 0,
            timer1: null,
        }
    },
    mounted() {
        this.setdata()
        this.timer1 = setInterval(() => {
            this.indexSumnew()
        }, 300)
        this.indexSumnew()
    },
    watch: {
        vdata(n) {
            this.setdata()
        }
    },
    methods: {
        setdata() {
            if (this.vdata) {
                const vdata = Object.keys(this.vdata)
                if (vdata.length) {
                    this.num1 = this.vdata.num1 || 0
                    this.num2 = this.vdata.num2 || 0
                    this.num3 = this.vdata.num3 || 0
                }
            }
        },
        numreduce(num, len) {
            let start = ''
            let numend = num.toString()
            if (numend.length < len) {
                for (let i = 0; i < (len - numend.length); i++) {
                    start = start + '0'
                }
            }
            return start + numend
        },
        indexSumnew() {
            if (+this.num1 !== +this.num1total || this.num1 == 0) {
                let num = this.numreduce(this.num1, this.num1length).split('')
                let strnum =  this.numreduce(this.num1total, this.num1length).split('')
                strnum.forEach((item, i) => {
                    if (+item < +num[i]) {
                        strnum[i] = +item + 1
                    }
                })
                this.num1total = strnum.join('')
            }
            if (+this.num2 !== +this.num2total || this.num2 == 0) {
                let num = this.numreduce(this.num2, this.num2length).split('')
                let strnum =  this.numreduce(this.num2total, this.num2length).split('')
                strnum.forEach((item, i) => {
                    if (+item < +num[i]) {
                        strnum[i] = +item + 1
                    }
                })
                this.num2total = strnum.join('')
            }
            if (+this.num3 !== +this.num3total || this.num3 == 0) {
                let num = this.numreduce(this.num3, this.num3length).split('')
                let strnum =  this.numreduce(this.num3total, this.num3length).split('')
                strnum.forEach((item, i) => {
                    if (+item < +num[i]) {
                        strnum[i] = +item + 1
                    }
                })
                this.num3total = strnum.join('')
            }
            if (+this.num1 == +this.num1total && +this.num2 == +this.num2total && +this.num3 == +this.num3total) {
                clearInterval(this.timer1)
                this.timer1 = null
                const _this = this
                setTimeout(() => {
                    this.num1total = 0
                    this.num2total = 0
                    this.num3total = 0
                    this.timer1 = setInterval(() => {
                        _this.indexSumnew()
                    }, 300);
                }, 5000)
            }
        },
    },
    beforeDestroy() {
        // 页面销毁清除定时器
        if (this.timer1) {
            clearInterval(this.timer1);
        }
    },
}
</script>

<style scoped lang="scss">
@font-face {
    font-family: "YeJinShuZi";
    src: url("../../assets/fonts/YeJinShuZi.woff2");
}

.contentNum {
    width: 92%;
    display: flex;
    justify-content: space-between;
    margin: 0px auto 0 auto;
    z-index: 999;
    position: relative;
}

.contentCenterTitle {
    font-size: 16px;
    color: #fff;
}

.centerNum {
    width: 41px;
    width: 41px;
    height: 54px;
    background: url(../../assets/template/num-bg.png) no-repeat;
    background-size: 100%;
    margin: 4px 6px 0 0;
    font-family: "lcdd";
    font-size: 45px;
    color: #fff;
    line-height: 50px;
    text-align: left;

    span {
        font-family: YeJinShuZi;
        padding-left: 7px;
    }
}

.dl {
    display: flex
}
</style>